import type { ReactNode } from "react";
import { Fragment } from "react";
import type { OptionDto } from "../../../../domain/types/company/company-product-system";

/**
 * 주문서에서 인쇄가 용지보다 먼저 오는지. 옵션 목록의 자리 순서로 정한다(예전 상품 설정 printBeforePaper 대체).
 * 낱장·롤은 인쇄 자리(PRINT)가 용지 자리(PAPER)보다 앞인지, 책자는 내지 자리(BOOK_INNER_PAPER)보다 앞인지 본다.
 * 자리 옵션이 없으면 예전 기본값처럼 용지가 먼저다.
 */
export const isPrintBeforePaper = (options: OptionDto[], isBookProduct: boolean): boolean => {
  const sorted = [...options].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0) || a.id - b.id);
  const printIndex = sorted.findIndex((option) => option.optionType === "PRINT");
  const paperIndex = sorted.findIndex((option) =>
    option.optionType === (isBookProduct ? "BOOK_INNER_PAPER" : "PAPER"));
  return printIndex !== -1 && paperIndex !== -1 && printIndex < paperIndex;
};

/** DOM order, not CSS order: keyboard and screen readers follow the same sequence. */
export function OrderedProductFields({ printBeforePaper, paper, printing }: {
  printBeforePaper?: boolean; paper: ReactNode; printing: ReactNode;
}) {
  const fields = { paper, printing };
  return <>{(printBeforePaper ? ["printing", "paper"] as const : ["paper", "printing"] as const)
    .map(key => <Fragment key={key}>{fields[key]}</Fragment>)}</>;
}
